// extracted by mini-css-extract-plugin
export default {"layout":"CompanyFirstLogin_layout__ed1Se","mainContainer":"CompanyFirstLogin_mainContainer__vQOnv","containerElement":"CompanyFirstLogin_containerElement__MWLiY"};